import { hasJoinedLeague } from 'src/replicant/match2/leagues/leagues.getters';
import { incrementSessionStat, resetSessionStat } from './stats.modifiers';
import { State } from 'src/replicant/State';
import StateObserver from 'src/StateObserver';

/**
 * Fire on puzzle start action. Increment puzzle attempts counters.
 */
export async function startPuzzleEvent(state: State) {
  // Ignore if player is in the master league
  if (hasJoinedLeague(state)) {
    return;
  }

  // Update generic puzzle attempts counters
  incrementSessionStat('puzzleAttempts');
  await StateObserver.invoke.incrementPersistentStat('puzzleAttempts');

  // Update puzzle attempts counters for current session
  incrementSessionStat('currentPuzzleAttempts');
  await StateObserver.invoke.incrementPersistentStat('currentPuzzleAttempts');
}

/**
 * Fire on puzzle complete action. Reset current level puzzle attempts counters.
 */
export async function completePuzzleEvent(
  state: State,
  result: 'win' | 'lose' | 'quit',
) {
  // Ignore if player is in the master league
  if (hasJoinedLeague(state)) {
    return;
  }

  // Reset puzzle attempts counters for current session if player win the puzzle
  if (result === 'win') {
    resetSessionStat('currentPuzzleAttempts');
    await StateObserver.invoke.resetPersistentStat('currentPuzzleAttempts');
  }
}
